import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
// Consider replacing these images with ones relevant to Anaesthesia/Surgery if available
import surgeryBg1 from './Anethesia.png'; // Kept original paths, rename/replace images as needed
import surgeryBg2 from '../../assets/img/clinic//2.png'; // Kept original paths, rename/replace images as needed
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Anaesthesia = () => {
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    // Use the imported images - update these if you have anaesthesia-specific visuals
    const images = [surgeryBg1];
     const backgroundImage = images[currentImageIndex];

    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            

            <div className="content">
              {/* Full-Width Background with Minimal Text - Kept urology-header class as requested */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                    <p>
                                       <br />
                                         <strong>Anaesthesia Department at Hitkari Hospital</strong>
                                          </p>

                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">

                             <div className="terms-content">
                                <div className="terms-text">
                                     <h3>Anaesthesia Department at Hitkari Hospital</h3>
                                       <p>The Department of Anaesthesia at Hitkari Hospital provides comprehensive anaesthetic and pain management services, ensuring patient safety and comfort throughout the perioperative period. Our team of highly qualified and experienced anaesthesiologists utilizes state-of-the-art technology and evidence-based practices to deliver exceptional care for a wide range of surgical, diagnostic, and therapeutic procedures. We are committed to personalized care, minimizing risks, and optimizing patient outcomes.</p>
                                </div>
                                <div className="terms-text">
                                    <h3>Services Offered by the Anaesthesia Department</h3>
                                    <h4>1. Pre-operative Anaesthesia Assessment and Planning</h4>
                                    <ul>
                                        <li>Comprehensive Evaluation: Thorough assessment of patient medical history, physical condition, and specific surgical needs to determine the safest anaesthesia plan.</li>
                                        <li>Risk Stratification: Identifying potential risks and developing strategies to mitigate them during surgery.</li>
                                        <li>Patient Education: Informing patients about the anaesthesia process, options available, and addressing any concerns.</li>
                                        <li>Optimisation of Co-existing Conditions: Collaborating with other specialists to manage chronic conditions (like diabetes, hypertension) before surgery.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                       <h4>2. Administration of Anaesthesia</h4>
                                        <ul>
                                            <li>General Anaesthesia: Inducing a controlled state of unconsciousness for major surgeries, ensuring the patient feels no pain and has no memory of the procedure.</li>
                                            <li>Regional Anaesthesia: Numbing a specific region of the body (e.g., spinal, epidural, nerve blocks) for surgeries on limbs, abdomen, or for childbirth pain relief.</li>
                                            <li>Monitored Anaesthesia Care (MAC) / Sedation: Providing sedation and pain control for minimally invasive procedures or diagnostics, allowing the patient to remain comfortable and cooperative.</li>
                                            <li>Local Anaesthesia: Numbing a small, specific area for minor procedures.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                      <h4>3. Intra-operative Monitoring and Management</h4>
                                      <ul>
                                            <li>Advanced Haemodynamic Monitoring: Continuous tracking of heart rate, blood pressure, oxygen levels, and other vital signs using sophisticated equipment.</li>
                                             <li>Airway Management: Ensuring a clear and secure airway throughout the procedure, including intubation when necessary.</li>
                                            <li>Fluid and Blood Product Management: Maintaining optimal fluid balance and administering transfusions as needed.</li>
                                            <li>Temperature Regulation: Monitoring and managing patient body temperature to prevent hypothermia.</li>
                                        </ul>
                                 </div>
                                   <div className="terms-text">
                                       <h4>4. Post-operative Pain Management</h4>
                                        <ul>
                                            <li>Acute Pain Service: Dedicated team managing pain immediately after surgery using multimodal approaches.</li>
                                            <li>Epidural Analgesia: Continuous pain relief delivered via an epidural catheter, often used after major abdominal or thoracic surgery.</li>
                                             <li>Patient-Controlled Analgesia (PCA): Empowering patients to self-administer pain medication within safe limits.</li>
                                             <li>Peripheral Nerve Blocks: Targeted nerve blocks to manage pain in specific limbs or areas post-surgery.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                         <h4>5. Specialized Anaesthesia Services</h4>
                                       <ul>
                                          <li>Obstetric Anaesthesia: Providing pain relief during labour (epidurals) and anaesthesia for Cesarean sections, ensuring the safety of both mother and baby.</li>
                                           <li>Pediatric Anaesthesia: Specialized care tailored to the unique physiological needs of infants and children undergoing surgery.</li>
                                           <li>Critical Care Support: Anaesthesiologists play a key role in managing critically ill patients in the Intensive Care Unit (ICU), particularly those requiring ventilator support.</li>
                                           <li>Anaesthesia for Outpatient Procedures: Safe and efficient anaesthesia techniques allowing patients to return home the same day.</li>
                                       </ul>
                                 </div>
                                 {/* Removed the 6th section (Neurocritical Care from Neurology) as 5 sections cover Anaesthesia well and maintain similar length */}
                                  <div className="terms-text">
                                    <h3>Why Choose the Anaesthesia Department at Hitkari Hospital?</h3>
                                      <ul>
                                           <li>Expert Anaesthesiologists: Highly skilled and board-certified specialists dedicated to patient safety and comfort.</li>
                                           <li>Advanced Monitoring Technology: State-of-the-art equipment for precise monitoring of vital functions during procedures.</li>
                                            <li>Comprehensive Pain Management: Multimodal strategies to effectively manage pain before, during, and after surgery.</li>
                                            <li>Patient-Centric Approach: Tailored anaesthesia plans based on individual patient needs and surgical requirements.</li>
                                           <li>Commitment to Safety: Strict adherence to safety protocols and best practices to minimize anaesthetic risks.</li>
                                           <li>Collaborative Care: Working closely with surgeons and other medical teams to ensure seamless and integrated patient care.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    <p>At Hitkari Hospital's Department of Anaesthesia, your safety and comfort are our utmost priorities. Our dedicated team ensures that you receive the highest standard of anaesthetic care, utilizing advanced techniques and compassionate service to support you through your medical procedures and recovery, contributing to a positive surgical experience.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Anaesthesia; // Make sure to export the correct component name